import { render, staticRenderFns } from "./ActiveEmployee.vue?vue&type=template&id=52b85f7d"
import script from "./ActiveEmployee.vue?vue&type=script&lang=js"
export * from "./ActiveEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports